import './EventsStyle.css'
import React, { useRef, useState } from 'react'
import SearchBar from '../../../components/SearchBar/SearchBar'
import Dropdown from '../../../components/Dropdown/Dropdown'
import Button from '../../../components/Button/Button'
import { useNavigate, useParams } from 'react-router-dom'
import Paginationarrow from '../../../components/Paginationarrow/Paginationarrow'
import Dorpwoncustom from '../../../components/Dorpwoncustom/Dorpwoncustom'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { adminData, clearEvents, getAllEventRegistrations } from '../../../reducer/adminSlice'
import PageLoader from '../../../components/loaders/PageLoader/PageLoader'
import DatanotFound from '../../../components/DatanotFound/DatanotFound'
import moment from 'moment'
import Skeleton from 'react-loading-skeleton'

const Eventstest = () => {

    //Search states
    const [search, setSearch] = useState("");

    //Load more states
    const [index, setIndex] = useState(1);
    const [totalEventDetails, setTotalEventDetails] = useState([]);

    const { isFetching, isSuccess, isError, errorMessage, eventDetails } = useSelector(adminData);

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { eventId } = useParams();

    //Search functions
    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearch(value);
    };

    const handleSearch = (e) => {
        setTotalEventDetails([]);
        setIndex(1);
        dispatch(getAllEventRegistrations({ eventId, search }));
    };

    const handleSearchPress = (e) => {
        if (e.key === "Enter") {
            setTotalEventDetails([]);
            setIndex(1);
            dispatch(getAllEventRegistrations({ eventId, search }));
        }
    };

    //Load more functions
    const handleLoadMore = () => {
        setIndex(prev => prev + 1);
        dispatch(getAllEventRegistrations({ eventId, index: index + 1 }));
    };

    useEffect(() => {
        dispatch(getAllEventRegistrations({ eventId }));

        return () => {
            dispatch(clearEvents());
        }
    }, []);

    useEffect(() => {
        if (index === 1 && eventDetails?.users?.length > 0) setTotalEventDetails(eventDetails?.users);
        if (index !== 1 && eventDetails?.users?.length > 0) setTotalEventDetails(prev => [...prev, ...eventDetails?.users]);
    }, [eventDetails?.users]);

    const targetRef = useRef(null);

    useEffect(() => {

        const element = document.querySelector(".CallHistoryTabledata");
        const element1 = document.querySelector(".innerdiv");

        const handleScroll = () => {
            if (targetRef.current) {
                const { top } = targetRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                if (top <= windowHeight) {
                    handleLoadMore();
                }
            }
        };

        element.addEventListener('scroll', handleScroll);
        element1.addEventListener('scroll', handleScroll);

        return () => {
            element.removeEventListener('scroll', handleScroll);
            element1.removeEventListener('scroll', handleScroll);
        };
    }, [handleLoadMore]);

    return (
        <>
            {/* {isFetching && <PageLoader />} */}
            <div>
                <div className='pathlinkwrapper flex gap-10'>
                    <img src='assets/img/calendartick.png' alt="" />
                    <p className='text2' onClick={() => navigate('/admin/events')}>Events</p>
                    <img src="/assets/img/arrowright.png" alt="" />
                    {isFetching ? <Skeleton width={"200px"} /> : <p className='text2'>{totalEventDetails?.length > 0 ? totalEventDetails[0]?.event?.title ?? "Current Event" : "Current Event"}</p>}
                </div>
                <div className='mt30'>
                    <h2 className='heading-2 mb6'>Event Leads {!isFetching && `(${eventDetails?.totalCount ?? 0})`}</h2>
                    {isFetching ? <Skeleton width={"150px"} /> : <p className='text3'>{`Since ${totalEventDetails?.length > 0 ? moment(totalEventDetails[0]?.event?.fromDate).format("DD MMMM, YYYY") ?? "---" : "---"}`}</p>}
                </div>
                <div className={`commonTableWrapper ContainerTabForAllTabData`}>
                    <div className='bodyDataForallUserdata'>
                        <div className="FaqUserFiltter flex-between">
                            {isFetching ? <Skeleton width={"280px"} height={"30px"} /> : <SearchBar placeholder={'Search here...'} className={'searchbardesign'} value={search} onChange={handleSearchChange} onClick={handleSearch} onKeyDown={handleSearchPress} />}
                            <div className="FilterButtonPast flex gap-10" >
                                {isFetching ? <Skeleton width={"200px"} height={"30px"} /> : <div className='dropdownbtnshow'>
                                    <input type='text' placeholder={`Showing ${totalEventDetails?.length ?? 0} out of ${eventDetails?.totalCount}`} disabled className='disabledInput' />
                                </div>}
                                {/* <Button name={'Filters'} src={'/assets/img/Filter list.png'} className={'filterbtn'} /> */}
                            </div>
                        </div>
                        {/* wrapperdivheight */}
                        <div className={`CallHistoryTabledata mt20 fixeventtextgap`}>
                            <div className="outerdiv">
                                <table>
                                    <thead>
                                        <tr className='headingTabletr'>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th> <div className="headingtablediv">Phone Number</div></th>
                                            <th> <div className="headingtablediv">Registration Date</div></th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>

                            <div className="innerdiv">
                                <table>
                                    <tbody>
                                        {totalEventDetails?.length > 0 ? totalEventDetails?.map((item, index) => (
                                            <tr key={index}>

                                                <td>
                                                    <div className='tableBox'>
                                                        <h4>{item?.name ? item?.name : "---"}</h4>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='tableBox'>
                                                        <div className='overfolwemail'>
                                                            <h4>{item?.email ? item?.email : "---"}</h4>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='tableBox'>
                                                        <h4>{item?.mobile ? item?.mobile : "---"}</h4>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='tableBox'>
                                                        <h4>{item?.registeredOn ? moment(item?.registeredOn).format("DD MMMM, YYYY") : "---"}</h4>
                                                    </div>
                                                </td>
                                            </tr>
                                        )) : !isFetching && <DatanotFound />}
                                        {isFetching &&
                                            <>
                                                {[1, 2, 3, 4, 5].map(item => (
                                                    <tr key={item}>

                                                        <td>
                                                            <div className='tableBox'>
                                                                <h4>{<Skeleton width={"100px"} />}</h4>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='tableBox'>
                                                                <div className='overfolwemail'>
                                                                    <h4>{<Skeleton width={"200px"} />}</h4>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='tableBox'>
                                                                <h4>{<Skeleton width={"100px"} />}</h4>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='tableBox'>
                                                                <h4>{<Skeleton width={"150px"} />}</h4>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>}
                                    </tbody>
                                </table>

                                {!isFetching && ((totalEventDetails?.length < eventDetails?.totalCount)) && <div className="lodeemorebutton mt10" ref={targetRef}>
                                    <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                                </div>}
                            </div>

                            {/* {!isFetching && ((totalEventDetails?.length < eventDetails?.totalCount)) && <div className="lodeemorebutton mt10" ref={targetRef}>
                                    <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                                </div>} */}
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default Eventstest